(() => {
  'use strict';
  let dispose;
  function init() {
    if (dispose) dispose();
    const header = document.querySelector('[data-wg-header]');
    if (!header) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const toggle = header.querySelector('[data-wg-menu-toggle]');
    const menu = header.querySelector('.wg-lv-mobile-nav');
    const close = (restoreFocus = false) => {
      if (!toggle || !menu) return;
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      header.classList.remove('menu-open');
      if (restoreFocus) toggle.focus();
    };
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 145);
    window.addEventListener('scroll', update, { ...options, passive: true });
    window.addEventListener('resize', () => { if (window.innerWidth >= 750) close(); }, options);
    toggle?.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header.classList.toggle('menu-open', open);
    }, options);
    menu?.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) close(true); }, options);
    document.addEventListener('click', event => { if (!header.contains(event.target)) close(); }, options);
    header.addEventListener('focusout', event => { if (!header.contains(event.relatedTarget)) close(); }, options);
    // Existing cart behavior lives in theme.js. Rebind only when Shopify replaces the header in the editor.
    if (header.dataset.editorLoaded === 'true') {
      header.querySelector('[data-cart-open]')?.addEventListener('click', () => window.WildGoatCart?.open(), options);
    }
    const ann = document.querySelector('[data-wg-ann]');
    const track = ann?.querySelector('.wg-lv-ann-track');
    const slides = track ? [...track.children] : [];
    if (slides.length > 1) {
      let index = 0;
      let timer;
      const show = next => {
        index = (next + slides.length) % slides.length;
        track.style.transform = `translateX(${-index * 100}%)`;
        slides.forEach((slide, n) => { slide.inert = n !== index; });
      };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); timer = setInterval(() => show(index + 1), 5000); };
      ann.addEventListener('click', event => {
        const step = event.target.closest('[data-wg-ann-step]');
        if (!step) return;
        show(index + Number(step.dataset.wgAnnStep));
        if (!ann.matches(':hover, :focus-within')) start();
      }, options);
      ann.addEventListener('mouseenter', stop, options);
      ann.addEventListener('mouseleave', start, options);
      ann.addEventListener('focusin', stop, options);
      ann.addEventListener('focusout', event => { if (!ann.contains(event.relatedTarget)) start(); }, options);
      controller.signal.addEventListener('abort', stop);
      show(0);
      start();
    }
    update();
    dispose = () => controller.abort();
  }
  init();
  document.addEventListener('shopify:section:load', event => {
    const header = event.target.querySelector('[data-wg-header]');
    if (header) { header.dataset.editorLoaded = 'true'; init(); }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-wg-header]') && dispose) dispose();
  });
})();
